export const wasabi = {
    wasabi100: '#f8faf6',
    wasabi200: '#f3f7ee',
    wasabi300: '#e2f6cd',
    wasabi400: '#d2f1b0',
    wasabi500: '#c1e895',
    wasabi600: '#b0db7c',
    wasabi700: '#9aca5d',
    wasabi800: '#7db51c',
    wasabi900: '#aced4c',
    wasabi1000: '#a2e33f',
    wasabi1100: '#507b00',
    wasabi1200: '#2f4313',
    wasabiAccentContrast: '#1c2510',
    wasabiAccentSurface: '#f3f7ee',
};

export const wasabiAlpha = {
    wasabi100: 'rgba(107, 180, 34, 0.03)',
    wasabi200: 'rgba(99, 167, 14, 0.06)',
    wasabi300: 'rgba(114, 220, 2, 0.19)',
    wasabi400: 'rgba(113, 216, 1, 0.3)',
    wasabi500: 'rgba(109, 204, 2, 0.41)',
    wasabi600: 'rgba(102, 187, 0, 0.51)',
    wasabi700: 'rgba(97, 173, 0, 0.63)',
    wasabi800: 'rgba(109, 172, 0, 0.89)',
    wasabi900: 'rgba(138, 231, 2, 0.7)',
    wasabi1000: 'rgba(133, 219, 1, 0.75)',
    wasabi1100: '#507b00',
    wasabi1200: 'rgba(30, 52, 0, 0.93)',
    wasabiAccentContrast: '#1c2510',
    wasabiAccentSurface: 'rgba(241, 246, 235, 0.8)',
};

export const wasabiDark = {
    wasabi100: '#0f120d',
    wasabi200: '#151912',
    wasabi300: '#212819',
    wasabi400: '#2b361f',
    wasabi500: '#364326',
    wasabi600: '#41512e',
    wasabi700: '#4d6136',
    wasabi800: '#5b733f',
    wasabi900: '#b3df7f',
    wasabi1000: '#a9d575',
    wasabi1100: '#b4e080',
    wasabiAccentContrast: '#ffffff',
    wasabiAccentSurface: '#151912',
};

export const wasabiDarkAlpha = {
    wasabi100: 'rgba(15, 18, 13, 0.01)',
    wasabi200: 'rgba(21, 25, 18, 0.04)',
    wasabi300: 'rgba(33, 40, 25, 0.11)',
    wasabi400: 'rgba(43, 54, 31, 0.18)',
    wasabi500: 'rgba(54, 67, 38, 0.24)',
    wasabi600: 'rgba(65, 81, 46, 0.31)',
    wasabi700: 'rgba(77, 97, 54, 0.38)',
    wasabi800: 'rgba(91, 115, 63, 0.45)',
    wasabi900: 'rgba(179, 223, 127, 0.7)',
    wasabi1000: 'rgba(169, 213, 117, 0.75)',
    wasabi1100: 'rgba(180, 224, 128, 0.83)',
    wasabi1200: 'rgba(30, 52, 0, 0.93)',
    wasabiAccentContrast: '#ffffff',
    wasabiAccentSurface: 'rgba(21, 25, 18, 0.5)',
};
